<template>
  <AdminLayout :title="$t('admin_member.member_manage')" :current="$c.ADMIN.TAB.MEMBER">
    <div class="section">
      <div class="container" align=center>
        <InputSearch style="width:80%; margin-bottom: 26px;" type="number" v-model="phone_num" :placeholder='$t("admin_member.mobile_phone")' @click="do_click"></InputSearch>
      <slot>
        <b-button style="width:80%" size="lg" block variant="none" class="btn-member" v-for="button in buttons" @click="button.func(button.arg)">{{$t(button.title)}}</b-button>
      </slot>
      </div>
    </div>
    <b-modal
      content-class="md_modal_content"
      centered
      :hide-header=true
      :hide-footer=true
      id="modal"
      key="1"
    >
      <div align="center" style="margin: 0.5em;">
        <p style="padding: 0.8em;">
          {{phone_num}}
          <br>
          <span>{{mo_title}}</span>
        </p>
        <b-button
          style="width: 20%; margin-right: 1.5em;"
          @click="cancel_modal"
          class="md_btn_light">{{$t('common.cancel1')}}</b-button>
        <b-button
          style="width: 20%"
          @click="ok_modal"
          class="md_btn_primary">{{$t('common.ok')}}</b-button>
      </div>
    </b-modal>
  </AdminLayout>
</template>
<script>
const $u = require('util');
import AdminLayout from './controls/adminlayout'
import InputSearch from './controls/input_search'
import Utils from "../../../../config/utils";
export default {
  name: "AdminMember",
  components: {
    AdminLayout,
    InputSearch
  },

  data() {
    return {
      phone_num: "",
      mo_title: null,
      buttons:[
        {title:"admin_member.add", func:this.add, arg:null},
        {title:"admin_member.db_view", func:this.db_view, arg:null},
        {title:"admin_member.remove", func:this.on_btn_clicked, arg:"remove"},
        {title:"admin_member.reject_subscription", func:this.on_btn_clicked, arg:"block"},
        {title:"admin_member.accept_subscription",  func:this.on_btn_clicked, arg:"allow"},
        {title:"admin_member.write_limit_5",  func:this.on_btn_clicked, arg:"w_limit"},
        {title:"admin_member.login_limit_5", func:this.on_btn_clicked, arg:"l_limit"},
      ],

      modals:{
        remove:{
          title:this.$t('admin_member.confirm_remove'),
          func:this.remove,
        },
        block:{
          title:this.$t('admin_member.confirm_reject_member'),
          func:this.block,
        },
        allow:{
          title:this.$t('admin_member.confirm_accept_member'),
          func:this.allow,
        },
        w_limit:{
          title:this.$t('admin_member.confirm_5_day_write_limit'),
          func:this.w_limit,
        },
        l_limit:{
          title:this.$t('admin_member.confirm_5_day_login_limit'),
          func:this.l_limit,
        }
      }

    }
  },
  methods:{
    ok_modal(){
    },

    cancel_modal(){
      this.$bvModal.hide('modal');
      this.$bvModal.msgBoxConfirm
    },

    is_phone_num(){
      if (this.phone_num !== ""){
        return true;
      }else{
        Utils.toast(this, this.$t('login.phone_placeholder'));
        return false;
      }
    },
    on_btn_clicked(k){
      if(this.is_phone_num()){
        this.mo_title = this.modals[k].title;
        var $this =this;
        this.ok_modal = function (){
          $this.modals[k].func();
          $this.cancel_modal();
        };
        this.$bvModal.show('modal');
      }
    },

    do_click:function (text){
      console.log(text);
      this.$emit('click');
    },

    add:function (){
      var $this = this;
      if(this.is_phone_num()){
        Utils.requestPost(this.$c.API.User.addPhoneNumber,
          {phone: this.phone_num.replaceAll('-', '')
          }
          ).then(result => {
          if (result.code === $this.$c.API_RES_CODE.SUCCESS) {
            Utils.toast($this, $this.$t('admin_member.msg_add_phone_success'))
          } else {
            Utils.toast($this, result.msg)
          }
        })
      }
    },

    db_view:function (){
      this.$router.push('/admin/db');
    },

    remove:function (){
      alert('remove');
      Utils.requestPost(
        this.$c.API.User.removeUserFromDB,
        {
          phone: this.phone_num.replaceAll('-', '')
        }
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          Utils.toast(this, this.$t('admin_member.msg_remove_user_success'));
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    block:function (){
      Utils.requestPost(
        this.$c.API.Admin.blockPhone,
        {
          phone: this.phone_num.replaceAll('-', ''),
        }
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          Utils.toast(this, this.$t('admin_member.msg_limit_user_success'));
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
    allow:function (){
      Utils.requestPost(
        this.$c.API.Admin.unblockPhone,
        {
          phone: this.phone_num.replaceAll('-', ''),
        }
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          Utils.toast(this, this.$t('admin_member.msg_lift_user_success'));
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
    w_limit:function (){
      Utils.requestPost(
        this.$c.API.User.changeUserStatus,
        {
          phone: this.phone_num.replaceAll('-', ''),
          status: 'WL'
        }
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          if (result.data != null && result.data.release_date != null ) {
            Utils.toast(this, $u.format(this.$t('admin_member.msg_write_limit_success'), moment(result.data.release_date).format('YY-MM-DD')));
          }
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
    l_limit:function (){
      Utils.requestPost(
        this.$c.API.User.changeUserStatus,
        {
          phone: this.phone_num.replaceAll('-', ''),
          status: 'LL'
        }
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          if (result.data != null && result.data.release_date != null ) {
            Utils.toast(this, $u.format(this.$t('admin_member.msg_login_limit_success'), moment(result.data.release_date).format('MM/DD')));
          }
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/main/admin/Admin.scss';
@import '../../../../assets/css/_vars.scss';

.btn-member{
  margin-top: 6px;
  height: 45px;
  background-color: #267fff;
  border-radius: 0;
  color: white;
  font-size: $fs_16;
  font-family: $korean_gd_13_r;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/AdminMember.vue